import { Redirect } from "react-router-dom";
import * as resourceService from "./resource.service";
import { lazyImportPath } from "../../core/lazy";
import { getSystemReleasePath } from "../../core/system";

function buildRouteItem(menu, pMenu) {
  if (2 === menu["category"]) {
    const item = {
      exact: true,
      children: [],
      id: menu["id"],
      pId: menu["pId"],
      meta: { title: menu["label"], icon: menu["icon"], },
      component: <Redirect to={getSystemReleasePath("/404")} />,
      path: pMenu ? `${pMenu["path"]}/${menu["name"]}` : getSystemReleasePath(`/${menu["name"]}`),
    };
    return item;
  } else if (3 === menu["category"]) {
    let page = (menu["url"] || "").replace("src/", "").replace(".js", "");
    page = page ? page : getSystemReleasePath("/404");
    const item = {
      id: menu["id"],
      component: lazyImportPath(page),
      meta: { title: menu["label"], icon: menu["icon"], },
      path: pMenu ? `${pMenu["path"]}/${menu["name"]}` : getSystemReleasePath(`/${menu["name"]}`),
    };
    return item;
  }
  return null;
}

function buildRoutes(routes, menus, pMenu) {
  menus.forEach(menu => {
    if (2 === menu["category"]) {
      // 节点
      if (!pMenu && !menu["pId"]) {
        // 根节点
        const item = buildRouteItem(menu);
        routes.push(item);
        buildRoutes(routes, menus, item);
      } else if (pMenu && pMenu["id"] === menu["pId"]) {
        // 子节点
        const item = buildRouteItem(menu, pMenu);
        pMenu.children.push(item);
        buildRoutes(routes, menus, item);
        if (1 === pMenu.children.length) {
          pMenu.component = () => <Redirect to={item["path"]} />;
        }
      }
    } else if (3 === menu["category"]) {
      // 叶子
      if (!pMenu && !menu["pId"]) {
        // 根叶子
        const item = buildRouteItem(menu);
        routes.push(item);
      } else if (pMenu && pMenu["id"] === menu["pId"]) {
        // 子叶子
        const item = buildRouteItem(menu, pMenu);
        pMenu.children.push(item);
        if (1 === pMenu.children.length) {
          pMenu.component = () => <Redirect to={item["path"]} />;
        }
      }
    }
  });
  return routes;
}

function buildRoutesByMenus(menus = []) {
  const routes = buildRoutes([], menus, null);
  if (routes.length) {
    const firstRoute = routes[0];
    const firstItem = {
      exact: true,
      hidden: true,
      path: getSystemReleasePath("/"),
      component: () => <Redirect to={firstRoute["path"]} />,
    };
    routes.splice(0, 0, firstItem);
  }
  return routes;
}

const INITIAL_STATE = {
  // 菜单列表
  menuList: [],
};

const resource = {
  state: {
    ...INITIAL_STATE,
  },
  actions: {
    getMenuList({ dispatch }, param) {
      return resourceService.getMenuList(param).then(res => {
        dispatch({ type: "resource/getMenuList", payload: res.data });
        return res;
      });
    },
  },
  reducers: {
    getMenuList(prevState, payload) {
      return {
        ...prevState,
        menuList: buildRoutesByMenus([...payload]),
      };
    },
  }
}

export default resource;
